module.exports = __webpack_public_path__ + "img/73.19387a6b.png";